import { useId } from "react";
import type { ReactNode } from "react";

import "./ui.css";

interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: ReactNode;
  sub?: ReactNode;
  disabled?: boolean;
  id?: string;
}

export function Switch({ checked, onChange, label, sub, disabled, id }: SwitchProps) {
  const generated = useId();
  const inputId = id ?? `switch-${generated}`;
  return (
    <label className="switch" htmlFor={inputId}>
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="switch__track" />
      {(label || sub) && (
        <span>
          {label && <span className="switch__label">{label}</span>}
          {sub && <span className="switch__sub">{sub}</span>}
        </span>
      )}
    </label>
  );
}
